import React, { useState } from 'react';
import { Form, Input, Button, message, Spin } from 'antd';
import { UserOutlined, LockOutlined, LoginOutlined } from '@ant-design/icons';
import { useAuth } from '../contexts/AuthContext';

function Karsilama() {
  const { login } = useAuth();
  const [showLogin, setShowLogin] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleLogin = async (values) => {
    setLoading(true);
    try {
      await login(values.email, values.sifre);
      message.success('Giris basarili!');
    } catch (err) {
      const msg = err.response?.data?.error || 'Giris basarisiz. Bilgilerinizi kontrol edin.';
      message.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #FFF8F0 0%, #FFE8D0 50%, #FFD4AA 100%)',
      position: 'relative',
      overflow: 'hidden',
    }}>
      {/* Dekoratif arka plan daireleri */}
      <div style={{
        position: 'absolute', top: -120, right: -120,
        width: 400, height: 400, borderRadius: '50%',
        background: 'rgba(255, 107, 0, 0.06)',
      }} />
      <div style={{
        position: 'absolute', bottom: -80, left: -80,
        width: 300, height: 300, borderRadius: '50%',
        background: 'rgba(255, 107, 0, 0.04)',
      }} />

      {/* Ana icerik */}
      <div style={{
        textAlign: 'center',
        zIndex: 1,
        padding: '0 24px',
      }}>
        {/* Logo */}
        <div style={{
          marginBottom: 12,
          animation: 'fadeInDown 0.6s ease-out',
        }}>
          <div style={{
            display: 'inline-block',
            padding: '20px 40px',
            borderRadius: 16,
            background: 'white',
            boxShadow: '0 8px 32px rgba(255, 107, 0, 0.15)',
          }}>
            <span style={{
              fontSize: 52,
              fontWeight: 900,
              letterSpacing: 8,
              color: '#FF6B00',
              fontFamily: "'Arial Black', 'Helvetica Neue', sans-serif",
            }}>
              EVDEYE
            </span>
          </div>
        </div>

        {/* Alt baslik */}
        <h2 style={{
          color: '#666',
          fontWeight: 400,
          fontSize: 18,
          marginBottom: 48,
          letterSpacing: 2,
        }}>
          Restoran Yonetim Sistemi
        </h2>

        {/* Login formu veya giris butonu */}
        {!showLogin ? (
          <div style={{ animation: 'fadeInUp 0.6s ease-out' }}>
            <Button
              type="primary"
              size="large"
              icon={<LoginOutlined />}
              onClick={() => setShowLogin(true)}
              style={{
                height: 52,
                paddingLeft: 40,
                paddingRight: 40,
                fontSize: 16,
                fontWeight: 600,
                borderRadius: 12,
                boxShadow: '0 4px 16px rgba(255, 107, 0, 0.3)',
              }}
            >
              Giris Yap
            </Button>
          </div>
        ) : (
          <div style={{
            background: 'white',
            borderRadius: 16,
            padding: '40px 36px 28px',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.08)',
            width: 380,
            maxWidth: '90vw',
            animation: 'fadeInUp 0.4s ease-out',
          }}>
            <h3 style={{
              marginBottom: 28,
              color: '#333',
              fontSize: 20,
              fontWeight: 600,
            }}>
              Hesabiniza Giris Yapin
            </h3>
            <Spin spinning={loading}>
              <Form
                onFinish={handleLogin}
                layout="vertical"
                size="large"
              >
                <Form.Item
                  name="email"
                  rules={[{ required: true, message: 'Email giriniz' }]}
                >
                  <Input
                    prefix={<UserOutlined style={{ color: '#bbb' }} />}
                    placeholder="Email"
                    autoFocus
                    style={{ borderRadius: 8, height: 46 }}
                  />
                </Form.Item>
                <Form.Item
                  name="sifre"
                  rules={[{ required: true, message: 'Sifre giriniz' }]}
                >
                  <Input.Password
                    prefix={<LockOutlined style={{ color: '#bbb' }} />}
                    placeholder="Sifre"
                    style={{ borderRadius: 8, height: 46 }}
                  />
                </Form.Item>
                <Form.Item style={{ marginBottom: 12 }}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    block
                    style={{
                      height: 46,
                      borderRadius: 8,
                      fontWeight: 600,
                      fontSize: 15,
                    }}
                  >
                    Giris Yap
                  </Button>
                </Form.Item>
                <Button
                  type="link"
                  onClick={() => setShowLogin(false)}
                  style={{ color: '#999', padding: 0 }}
                >
                  Geri Don
                </Button>
              </Form>
            </Spin>
          </div>
        )}

        {/* Alt bilgi */}
        <div style={{
          marginTop: 64,
          color: '#bbb',
          fontSize: 12,
          letterSpacing: 1,
        }}>
          EVDEYE &copy; 2025 &mdash; Tum haklari saklidir.
        </div>
      </div>

      {/* CSS Animasyonlari */}
      <style>{`
        @keyframes fadeInDown {
          from { opacity: 0; transform: translateY(-20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}

export default Karsilama;
